import Image from "next/image";

import { SABINE_DIRECT_AVATAR_SRC } from "@/lib/sabine";
import { cn } from "@/lib/utils";

/**
 * Sabine's face at icon size, for the Chats menu's rail button: it says whose
 * chats they are where a glyph could not. Sized by `className` like the line
 * icons beside it, and decorative, since the button carries its own label.
 */
export default function SabineFace({ className }) {
  return (
    <Image
      src={SABINE_DIRECT_AVATAR_SRC}
      alt=""
      aria-hidden="true"
      width={24}
      height={24}
      className={cn("rounded-full object-cover object-top", className)}
    />
  );
}
